export const Iframe = ({ uri, type }: { uri: string; type: string }) => {
  const formatYoutubeURI = (uri: string) => {
    const yt_id = uri.split("v=")[1];
    return `https://www.youtube.com/embed/${yt_id}`;
  };

  const formatWistiaURI = (uri: string) => {
    const wistia_id = uri.split("medias/")[1];
    return `https://naturalheroes.wistia.com/embed/iframe/${wistia_id}?videoFoam=true&fitStrategy=contain`;
  };

  if (type === "youtube") {
    return (
      <iframe
        width="100%"
        height="100%"
        src={formatYoutubeURI(uri)}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    );
  } else if (type === "wistia") {
    return (
      <iframe
        src={formatWistiaURI(uri)}
        name="wistia_embed"
        frameBorder="0"
        scrolling="no"
        width="100%"
        height="100%"
      ></iframe>
    );
  }
};
